import { LocalVideoPlayer } from "@/components/ui/local-video-player";
import { getUseCaseByIndex, getUseCaseById } from "../use-cases-registry";

interface VideoContainerProps {
  useCaseIndex?: number;
  useCaseId?: string;
}

export function VideoContainer({ useCaseIndex, useCaseId }: VideoContainerProps) {
  // Prefer ID lookup for stability, fall back to index for scroll transitions
  const useCase = useCaseId 
    ? getUseCaseById(useCaseId)
    : useCaseIndex !== undefined 
      ? getUseCaseByIndex(useCaseIndex)
      : undefined;

  if (!useCase) {
    return null;
  }

  return (
    <div className="w-full h-full overflow-hidden">
      <LocalVideoPlayer
        src={useCase.videoPath}
        poster={useCase.posterPath}
        className="w-full h-full [&>video]:object-cover [&>video]:object-top [&>video]:w-full [&>video]:h-full"
        muted={true}
      />
    </div>
  );
}